<template>
  <slot v-bind="{ handleTrackAddPaymentInfo }"/>
</template>

<script>
import { mapGtmItemsFromOrder, trackAddPaymentInfo } from '../../gtm'

export default {
  props: {
    currency: String,
    price: Number,
    coupon: String,
    paymentType: String,
    products: Array,
    enableMounted: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    handleTrackAddPaymentInfo() {
      trackAddPaymentInfo(
        mapGtmItemsFromOrder(
          this.products,
          'order', 
        ),
        this.currency, 
        this.price, 
        this.paymentType,
        this.coupon, 
      )
    }
  },
  mounted() {
    if (!this.enableMounted) {
      return
    }

    this.handleTrackAddPaymentInfo()
  }
}
</script>
